module.exports = __webpack_public_path__ + "static/img/2.ed2a816.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/6/2.png
// module id = YXDq
// module chunks = 2